import { SVGProps, Ref, forwardRef } from 'react';

export const MagnifierPlusFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.247.497c-5.063 0-6.75 3.375-6.75 6.75s1.687 6.75 6.75 6.75c1.952 0 3.402-.502 4.448-1.313L14.51 15.5l.99-.99-2.822-2.822c.94-1.24 1.319-2.84 1.319-4.441 0-3.375-1.688-6.75-6.75-6.75M7.947 4v2.55h2.55v1.4h-2.55v2.55h-1.4V7.95h-2.55v-1.4h2.55V4z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
MagnifierPlusFilledSize16Glyph.displayName = 'MagnifierPlusFilledSize16Glyph';
